export default "__VITE_ASSET__NJ1TJr1L__"